export default __webpack_public_path__ + "static/media/Shot_21.0000.eb5db7af.png";